import {
  base_colorContentBorder,
  base_colorRaisedSurface,
  text_colorTextPrimary,
  text_colorTextSecondary,
} from 'ext-ui/style/colors'
import { cornerRadius, spacing } from 'ext-ui/style/spacing'
import { chartPanel, chartTitle } from 'src/charting/reportingCardLayout.style'
import styled, { css } from 'styled-components'

export const ArtifactCardShell = styled.section<{ $pinned?: boolean }>`
  min-width: 0;
  display: flex;
  flex-direction: column;
  gap: ${spacing(3)};
  padding: ${spacing(4)};
  border: 1px solid ${base_colorContentBorder};
  border-radius: ${cornerRadius};
  background: ${base_colorRaisedSurface};

  ${({ $pinned }) =>
    $pinned &&
    css`
      ${chartPanel}
      min-height: 0;
      overflow: hidden;
    `}
`

export const ArtifactCardHeader = styled.header`
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: ${spacing(3)};
`

export const ArtifactCardTitleRow = styled.div`
  min-width: 0;
  display: flex;
  align-items: center;
  gap: ${spacing(2)};
`

export const ArtifactCardHeading = styled.h3`
  ${chartTitle}
  min-width: 0;
`

export const PinButton = styled.button`
  flex: 0 0 auto;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  margin: -${spacing(1)};
  padding: ${spacing(1)};
  border: 0;
  border-radius: ${cornerRadius};
  background: transparent;
  color: ${text_colorTextSecondary};
  cursor: pointer;

  &:hover:not(:disabled),
  &:focus-visible {
    color: ${text_colorTextPrimary};
  }

  &:focus-visible {
    outline: 2px solid ${text_colorTextPrimary};
    outline-offset: ${spacing(1)};
  }

  &:disabled {
    cursor: default;
    opacity: 0.6;
  }
`
